export const getApiErrorMessageFromResponse = (apiResponse: any) => {
  try {
    return apiResponse.error.message;
  } catch (noApiErrorMessageException) {
    return apiResponse;
  }
};
